"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.resetCalendarSelection = exports.selectDataTable = exports.setDataTableRows = exports.setDataTableSortingOption = exports.setDataTablePage = exports.initializeDataTable = exports.updateNamedCalendarRanges = exports.updateCalendarRanges = exports.datepickerLensForId = exports.forDatepicker = exports.selectPaginationValue = exports.setPaginationValue = exports.initializePagination = exports.selectTab = exports.setSlidingPanelActiveState = exports.expandFilterDropdown = exports.hideFilterDropdown = exports.toggleFilterDropdown = exports.toggleSlidingPanel = exports.toggleSideNavLinkGroup = exports.selectCollaspedStateFromSideNav = exports.toggleSideNav = exports.toggleNavGroup = exports.createNavGroupKey = exports.closeAlert = exports.openAlert = exports.closeModal = exports.openModal = void 0;

var R = _interopRequireWildcard(require("ramda"));

var _reduxActions = require("redux-actions");

var _sortingHelper = require("@cjdev-internal/visual-stack/lib/components/Table/DataTable/sortingHelper");

var _handleActions;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultToEmpty = R.defaultTo({});
var defaultToEmptyArray = R.defaultTo([]);
var collapse = R.set(R.lensProp('expanded'), false);
var OPEN_MODAL = '@cjdev-internal/visual-stack-redux/OPEN_MODAL';
var CLOSE_MODAL = '@cjdev-internal/visual-stack-redux/CLOSE_MODAL';
var openModal = (0, _reduxActions.createAction)(OPEN_MODAL, function (component, props) {
  return {
    component: component,
    props: props
  };
});
exports.openModal = openModal;
var closeModal = (0, _reduxActions.createAction)(CLOSE_MODAL);
exports.closeModal = closeModal;
var emptyModalState = {
  component: undefined,
  props: undefined
};
var OPEN_ALERT = '@cjdev-internal/visual-stack-redux/OPEN_ALERT';
var CLOSE_ALERT = '@cjdev-internal/visual-stack-redux/CLOSE_ALERT';
var openAlert = (0, _reduxActions.createAction)(OPEN_ALERT, function (component, props) {
  return {
    component: component,
    props: props
  };
});
exports.openAlert = openAlert;
var closeAlert = (0, _reduxActions.createAction)(CLOSE_ALERT);
exports.closeAlert = closeAlert;
var emptyAlertState = {
  component: undefined,
  props: undefined
};
var REGISTER_DROPDOWN = '@cjdev-internal/visual-stack-redux/REGISTER_DROPDOWN';
var TOGGLE_DROPDOWN = '@cjdev-internal/visual-stack-redux/TOGGLE_DROPDOWN';
var createNavGroupKey = (0, _reduxActions.createAction)(REGISTER_DROPDOWN);
exports.createNavGroupKey = createNavGroupKey;
var toggleNavGroup = (0, _reduxActions.createAction)(TOGGLE_DROPDOWN);
exports.toggleNavGroup = toggleNavGroup;
var TOGGLE_SIDENAV = '@cjdev-internal/visual-stack-redux/TOGGLE_SIDENAV';
var toggleSideNav = (0, _reduxActions.createAction)(TOGGLE_SIDENAV, function (collapsed) {
  return {
    collapsed: collapsed
  };
});
exports.toggleSideNav = toggleSideNav;

var selectCollaspedStateFromSideNav = function selectCollaspedStateFromSideNav(state) {
  return state.visualStack.sideNav.collapsed;
};

exports.selectCollaspedStateFromSideNav = selectCollaspedStateFromSideNav;
var TOGGLE_SIDENAV_LINKGROUP = '@cjdev-internal/visual-stack-redux/TOGGLE_SIDENAV_LINKGROUP';
var toggleSideNavLinkGroup = (0, _reduxActions.createAction)(TOGGLE_SIDENAV_LINKGROUP, function (expanded, linkGroupName) {
  return {
    expanded: expanded,
    linkGroupName: linkGroupName
  };
});
exports.toggleSideNavLinkGroup = toggleSideNavLinkGroup;
var TOGGLE_SLIDING_PANEL = '@cjdev-internal/visual-stack-redux/TOGGLE_SLIDING_PANEL';
var toggleSlidingPanel = (0, _reduxActions.createAction)(TOGGLE_SLIDING_PANEL);
exports.toggleSlidingPanel = toggleSlidingPanel;
var TOGGLE_SLIDING_PANEL_FILTER_DROPDOWN = '@cjdev-internal/visual-stack-redux/TOGGLE_SLIDING_PANEL_FILTER_DROPDOWN';
var toggleFilterDropdown = (0, _reduxActions.createAction)(TOGGLE_SLIDING_PANEL_FILTER_DROPDOWN, function (filterLabel) {
  return {
    filterLabel: filterLabel
  };
});
exports.toggleFilterDropdown = toggleFilterDropdown;
var HIDE_SLIDING_PANEL_FILTER_DROPDOWN = '@cjdev-internal/visual-stack-redux/HIDE_SLIDING_PANEL_FILTER_DROPDOWN';
var hideFilterDropdown = (0, _reduxActions.createAction)(HIDE_SLIDING_PANEL_FILTER_DROPDOWN, function (filterLabel) {
  return {
    filterLabel: filterLabel
  };
});
exports.hideFilterDropdown = hideFilterDropdown;
var EXPAND_SLIDING_PANEL_FILTER_DROPDOWN = '@cjdev-internal/visual-stack-redux/EXPAND_SLIDING_PANEL_FILTER_DROPDOWN';
var expandFilterDropdown = (0, _reduxActions.createAction)(EXPAND_SLIDING_PANEL_FILTER_DROPDOWN, function (filterLabel) {
  return {
    filterLabel: filterLabel
  };
});
exports.expandFilterDropdown = expandFilterDropdown;
var SET_SLIDING_PANEL_ACTIVE_STATE = '@cjdev-internal/visual-stack-redux/SET_SLIDING_PANEL_ACTIVE_STATE';
var setSlidingPanelActiveState = (0, _reduxActions.createAction)(SET_SLIDING_PANEL_ACTIVE_STATE);
exports.setSlidingPanelActiveState = setSlidingPanelActiveState;
var SELECT_TAB = '@cjdev-internal/visual-stack-redux/SELECT_TAB';
var selectTab = (0, _reduxActions.createAction)(SELECT_TAB);
exports.selectTab = selectTab;
var INITIALIZE_PAGINATION = '@cjdev-internal/visual-stack-redux/INITIALIZE_PAGINATION';
var initializePagination = (0, _reduxActions.createAction)(INITIALIZE_PAGINATION);
exports.initializePagination = initializePagination;
var SET_PAGINATION_VALUE = '@cjdev-internal/visual-stack-redux/SET_PAGINATION_VALUE';
var setPaginationValue = (0, _reduxActions.createAction)(SET_PAGINATION_VALUE);
exports.setPaginationValue = setPaginationValue;

var selectPaginationValue = function selectPaginationValue(state, ownProps) {
  return R.defaultTo({
    rowsPerPage: 10,
    page: 1
  })(state.visualStack.pagination[ownProps.paginationId]);
};

exports.selectPaginationValue = selectPaginationValue;
var forDatepicker = R.assocPath(['payload', 'datePickerId']);
exports.forDatepicker = forDatepicker;
var datepickerLensForId = R.memoizeWith(R.identity, function (id) {
  return R.lensPath(['visualStack', 'datePicker', id]);
});
exports.datepickerLensForId = datepickerLensForId;
var UPDATE_CALENDAR_RANGE = '@cjdev-internal/visual-stack-redux/UPDATE_CALENDAR_RANGE';
var updateCalendarRanges = (0, _reduxActions.createAction)(UPDATE_CALENDAR_RANGE, function (selectedRanges) {
  return {
    selectedRanges: selectedRanges
  };
});
exports.updateCalendarRanges = updateCalendarRanges;
var UPDATE_NAMED_CALENDAR_RANGES = '@cjdev-internal/visual-stack-redux/UPDATE_NAMED_CALENDAR_RANGES';
var updateNamedCalendarRanges = (0, _reduxActions.createAction)(UPDATE_NAMED_CALENDAR_RANGES, function (selectedNamedRanges) {
  return {
    selectedNamedRanges: selectedNamedRanges
  };
});
exports.updateNamedCalendarRanges = updateNamedCalendarRanges;

var findSortingIndex = function findSortingIndex(sortingOption, columns) {
  return R.findIndex(R.propEq('label', sortingOption.label))(columns);
};

var getDataTableData = function getDataTableData(_ref) {
  var columns = _ref.columns,
      data = _ref.data,
      sortingOption = _ref.sortingOption;
  var dataWithSelectedProp = defaultToEmptyArray(data).map(function (row, index) {
    return {
      id: index,
      row: row,
      selected: false
    };
  });
  if (!sortingOption) return dataWithSelectedProp;
  var sortingIndex = findSortingIndex(sortingOption, columns);
  return (0, _sortingHelper.sortData)(sortingIndex, sortingOption.order, dataWithSelectedProp);
};

var INITIALIZE_DATA_TABLE = '@cjdev-internal/visual-stack-redux/INITIALIZE_DATA_TABLE';
var initializeDataTable = (0, _reduxActions.createAction)(INITIALIZE_DATA_TABLE);
exports.initializeDataTable = initializeDataTable;
var SET_DATA_TABLE_PAGE = '@cjdev-internal/visual-stack-redux/SET_DATA_TABLE_PAGE';
var setDataTablePage = (0, _reduxActions.createAction)(SET_DATA_TABLE_PAGE);
exports.setDataTablePage = setDataTablePage;
var SET_DATA_TABLE_SORTING_OPTION = '@cjdev-internal/visual-stack-redux/SET_DATA_TABLE_SORTING_OPTION';
var setDataTableSortingOption = (0, _reduxActions.createAction)(SET_DATA_TABLE_SORTING_OPTION);
exports.setDataTableSortingOption = setDataTableSortingOption;
var SET_DATA_TABLE_ROWS = '@cjdev-internal/visual-stack-redux/SET_DATA_TABLE_ROWS';
var setDataTableRows = (0, _reduxActions.createAction)(SET_DATA_TABLE_ROWS);
exports.setDataTableRows = setDataTableRows;

var selectDataTable = function selectDataTable(id) {
  return function (state) {
    var dataTable = R.view(R.lensPath(['visualStack', 'dataTable', id]))(state);
    var defaultTable = {
      data: [],
      pagination: {}
    };
    return dataTable || defaultTable;
  };
};

exports.selectDataTable = selectDataTable;
var RESET_CALENDAR_SELECTION = '@cjdev-internal/visual-stack-redux/RESET_CALENDAR_SELECTION';
var resetCalendarSelection = (0, _reduxActions.createAction)(RESET_CALENDAR_SELECTION);
exports.resetCalendarSelection = resetCalendarSelection;

var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, OPEN_MODAL, function (state, _ref2) {
  var payload = _ref2.payload;
  return R.set(R.lensProp('modal'), payload, state);
}), _defineProperty(_handleActions, CLOSE_MODAL, function (state) {
  return R.set(R.lensProp('modal'), emptyModalState, state);
}), _defineProperty(_handleActions, OPEN_ALERT, function (state, _ref3) {
  var payload = _ref3.payload;
  return R.set(R.lensProp('alert'), payload, state);
}), _defineProperty(_handleActions, CLOSE_ALERT, function (state) {
  return R.set(R.lensProp('alert'), emptyAlertState, state);
}), _defineProperty(_handleActions, REGISTER_DROPDOWN, function (state, _ref4) {
  var payload = _ref4.payload;
  return R.over(R.lensProp('navGroupDropdown'), R.assoc(payload, false), state);
}), _defineProperty(_handleActions, TOGGLE_DROPDOWN, function (state, _ref5) {
  var payload = _ref5.payload;
  return R.over(R.lensPath(['navGroupDropdown', payload]), R.not, state);
}), _defineProperty(_handleActions, TOGGLE_SIDENAV, function (state, _ref6) {
  var collapsed = _ref6.payload.collapsed;
  return R.set(R.lensPath(['sideNav', 'collapsed']), collapsed, state);
}), _defineProperty(_handleActions, TOGGLE_SIDENAV_LINKGROUP, function (state, _ref7) {
  var _ref7$payload = _ref7.payload,
      expanded = _ref7$payload.expanded,
      linkGroupName = _ref7$payload.linkGroupName;
  var linkGroups = defaultToEmpty(R.view(R.lensPath(['sideNav', 'linkGroups']), state));
  var stateWithResetLinkGroups = R.set(R.lensPath(['sideNav', 'linkGroups']), R.map(function (v) {
    return collapse(v);
  })(linkGroups), state);
  return R.set(R.lensPath(['sideNav', 'linkGroups', linkGroupName, 'expanded']), expanded, stateWithResetLinkGroups);
}), _defineProperty(_handleActions, TOGGLE_SLIDING_PANEL, function (state) {
  return R.over(R.lensPath(['slidingPanel', 'active']), R.not, state);
}), _defineProperty(_handleActions, TOGGLE_SLIDING_PANEL_FILTER_DROPDOWN, function (state, _ref8) {
  var filterLabel = _ref8.payload.filterLabel;
  return R.over(R.lensPath(['slidingPanel', filterLabel, 'expanded']), R.not, state);
}), _defineProperty(_handleActions, HIDE_SLIDING_PANEL_FILTER_DROPDOWN, function (state, _ref9) {
  var filterLabel = _ref9.payload.filterLabel;
  return R.set(R.lensPath(['slidingPanel', filterLabel, 'expanded']), false, state);
}), _defineProperty(_handleActions, EXPAND_SLIDING_PANEL_FILTER_DROPDOWN, function (state, _ref10) {
  var filterLabel = _ref10.payload.filterLabel;
  return R.set(R.lensPath(['slidingPanel', filterLabel, 'expanded']), true, state);
}), _defineProperty(_handleActions, SET_SLIDING_PANEL_ACTIVE_STATE, function (state, _ref11) {
  var newActiveState = _ref11.payload;
  return R.set(R.lensPath(['slidingPanel', 'active']), newActiveState, state);
}), _defineProperty(_handleActions, SELECT_TAB, function (state, _ref12) {
  var _ref12$payload = _ref12.payload,
      tabLayoutId = _ref12$payload.tabLayoutId,
      index = _ref12$payload.index;
  return R.set(R.lensPath(['tabLayout', tabLayoutId, 'index']), index, state);
}), _defineProperty(_handleActions, INITIALIZE_PAGINATION, function (state, _ref13) {
  var paginationId = _ref13.payload.paginationId;
  return R.set(R.lensPath(['pagination', paginationId]), {
    page: 1,
    rowsPerPage: 10
  }, state);
}), _defineProperty(_handleActions, SET_PAGINATION_VALUE, function (state, _ref14) {
  var _ref14$payload = _ref14.payload,
      paginationId = _ref14$payload.paginationId,
      page = _ref14$payload.page,
      rowsPerPage = _ref14$payload.rowsPerPage;
  return R.set(R.lensPath(['pagination', paginationId]), {
    page: page,
    rowsPerPage: rowsPerPage
  }, state);
}), _defineProperty(_handleActions, UPDATE_CALENDAR_RANGE, function (state, _ref15) {
  var _ref15$payload = _ref15.payload,
      datePickerId = _ref15$payload.datePickerId,
      selectedRanges = _ref15$payload.selectedRanges;
  return R.set(R.lensPath(['datePicker', datePickerId, 'selectedRanges']), selectedRanges, state);
}), _defineProperty(_handleActions, UPDATE_NAMED_CALENDAR_RANGES, function (state, _ref16) {
  var _ref16$payload = _ref16.payload,
      datePickerId = _ref16$payload.datePickerId,
      selectedNamedRanges = _ref16$payload.selectedNamedRanges;
  return R.set(R.lensPath(['datePicker', datePickerId, 'selectedNamedRanges']), selectedNamedRanges, state);
}), _defineProperty(_handleActions, RESET_CALENDAR_SELECTION, function (state, _ref17) {
  var datePickerId = _ref17.payload.datePickerId;
  return R.set(R.lensPath(['datePicker', datePickerId]), {}, state);
}), _defineProperty(_handleActions, INITIALIZE_DATA_TABLE, function (state, _ref18) {
  var payload = _ref18.payload;
  return R.set(R.lensPath(['dataTable', payload.id]), {
    data: getDataTableData(payload),
    pagination: {
      page: 1,
      rowsPerPage: 10
    },
    sortingOption: R.compose(R.defaultTo({}), R.prop('sortingOption'))(payload)
  }, state);
}), _defineProperty(_handleActions, SET_DATA_TABLE_PAGE, function (state, _ref19) {
  var _ref19$payload = _ref19.payload,
      id = _ref19$payload.id,
      pagination = _ref19$payload.pagination;
  return R.set(R.lensPath(['dataTable', id, 'pagination']), pagination, state);
}), _defineProperty(_handleActions, SET_DATA_TABLE_SORTING_OPTION, function (state, _ref20) {
  var _ref20$payload = _ref20.payload,
      id = _ref20$payload.id,
      sortingOption = _ref20$payload.sortingOption;
  return R.set(R.lensPath(['dataTable', id, 'sortingOption']), sortingOption, state);
}), _defineProperty(_handleActions, SET_DATA_TABLE_ROWS, function (state, _ref21) {
  var _ref21$payload = _ref21.payload,
      id = _ref21$payload.id,
      data = _ref21$payload.data;
  return R.set(R.lensPath(['dataTable', id, 'data']), data, state);
}), _handleActions), {
  menuBar: {},
  modal: emptyModalState,
  alert: emptyAlertState,
  navGroupDropdown: {},
  sideNav: {},
  slidingPanel: {},
  tabLayout: {},
  pagination: {},
  datePicker: {},
  dataTable: {}
});

exports.default = _default;